import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchMonthlyLeadsReport } from "../../../state/reducers/MonthlyLeadsSlice";
import { Bar } from "react-chartjs-2";

const MonthlyLeadsChart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, list, status, error } = useSelector(
    (state) => state.monthlyLeads
  );

  const [month, setMonth] = useState(new Date().getMonth() + 1); // Default to current month
  const [year, setYear] = useState(new Date().getFullYear()); // Default to current year

  useEffect(() => {
    dispatch(fetchMonthlyLeadsReport({ month, year }));
  }, [dispatch, month, year]);

  const handleMonthChange = (e) => {
    setMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setYear(e.target.value);
  };

  if (status === "loading") return <p>Loading...</p>;
  if (status === "failed") return <p>Error: {error}</p>;
  const chartData = {
    labels: data.data ? data.data.map((item) => item.date) : [], // Use `date` for labels
    datasets: [
      {
        label: "Leads Count",
        data: data.data ? data.data.map((item) => item.count) : [], // Use `count` for data points
        backgroundColor: "#4CAF50",
        borderColor: "#388E3C",
        borderWidth: 1,
      },
    ],
  };
  const handleShowData = () => {
    navigate("/admin/data-table", { state: { leadsData: list } }); // Pass the data as route state
  };
  return (
    <div className="bg-white p-6">
      <h2 className="text-xl font-bold mb-4">Monthly Leads Report</h2>

      <div className="flex gap-4 mb-4">
        <div>
          <label className="block mb-1">Select Month:</label>
          <select
            value={month}
            onChange={handleMonthChange}
            className="border rounded px-2 py-1"
          >
            {[...Array(12).keys()].map((m) => (
              <option key={m + 1} value={m + 1}>
                {new Date(0, m).toLocaleString("default", { month: "long" })}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block mb-1">Select Year:</label>
          <input
            type="number"
            value={year}
            onChange={handleYearChange}
            className="border rounded px-2 py-1"
          />
        </div>
      </div>
      <button
        onClick={handleShowData}
        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Show Data
      </button>
      <Bar data={chartData} />

      {/* {data.length > 0 ? (
        <table className="mt-6 w-full border-collapse border border-gray-300">
          <thead>
            <tr>
              <th className="border px-4 py-2">Date</th>
              <th className="border px-4 py-2">Leads Count</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td className="border px-4 py-2">{item.date}</td>
                <td className="border px-4 py-2">{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="mt-4">No data available for the selected month and year.</p>
      )} */}
    </div>
  );
};

export default MonthlyLeadsChart;
